<template>
  <article class="content">
    <h1 class="title">{{ title }}</h1>
    <p v-if="startingPrice" class="price">
      Starting at <span>{{ startingPrice }}</span>
    </p>

    <div v-if="overview" class="card">
      <h3 class="section-heading">Overview:</h3>
      <p class="lead">{{ overview }}</p>
    </div>

    <div class="card">
      <h3 class="section-heading">What You Can Expect:</h3>
      <ul v-if="bullets?.length" class="bullets">
        <li v-for="(b, i) in bullets" :key="i">{{ b }}</li>
      </ul>

      <div v-if="note" class="note">
        <h3 class="section-heading">Note:</h3>
        <p class="lead">{{ note }}</p>
      </div>

      <router-link v-if="ctaRoute" :to="ctaRoute" class="cta">
        {{ ctaText }}
        <v-icon icon="mdi-arrow-right" class="cta-icon" />
      </router-link>
    </div>
  </article>
</template>

<script>
export default {
  name: 'ServicePackageContent',
  props: {
    title: { type: String, required: true },
    startingPrice: { type: String, default: '' },
    overview: { type: String, default: '' },
    bullets: { type: Array, default: () => [] },
    note: { type: String, default: '' },
    ctaRoute: { type: String, default: '/schedule-a-meeting' },
    ctaText: { type: String, default: 'Let’s Map Your Next Milestone' },
  },
  mounted() {
    const loader = document.getElementById('loaderSection');
    if (loader) loader.classList.add('d-none');
  },
};
</script>

<style scoped>
.content {
  background: #ffffff;
  border-radius: 8px;
  padding: 24px;
  text-align: left;
}
.title {
  font-size: 2rem;
  font-weight: 800;
  color: #0f172a;
  margin: 4px 0 8px;
}
.price {
  color: #ef4444;
  font-weight: 700;
  margin-bottom: 18px;
}
.price span { font-variant-numeric: tabular-nums; }

.card {
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 18px 20px;
  margin-top: 14px;
}
.section-heading {
  font-size: 1.125rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 10px;
}
.lead { color: #374151; line-height: 1.65; }
.bullets { margin: 8px 0 14px 18px; color: #374151; line-height: 1.7; }
.bullets li { margin: 6px 0; list-style: disc; }

.cta {
  display: inline-flex;
  gap: 10px;
  align-items: center;
  padding: 10px 16px;
  border-radius: 8px;
  text-decoration: none;
  background: #0b72b9;
  color: #ffffff;
  font-weight: 600;
}
.cta:hover { filter: brightness(1.05); }
.cta-icon { font-size: 18px; }

.note { margin-top: 12px; margin-bottom: 2rem; }
</style>
